import { ClientBooking } from "../../ClientBooking";
import { AssistantBookingScope } from "./AssistantBookingScope";

/**
 * EA books a trip on behalf of a CONNECTED managed client (DEV-1296) — the shared booking sheet
 * under the assistant scope (slim banner, NOT the Manage-Client takeover chrome). Mirrors the
 * operator OBO wrapper (OperatorClientBooking).
 */
export const AssistantClientBooking = () => (
  <AssistantBookingScope>
    <ClientBooking />
  </AssistantBookingScope>
);
